/**
 * @documental
 * @export Text
 * @name
 * Table.Text
 */
import { FC } from "react";

import { BaseColumnProps } from "../BaseColumnProps";
import { ColumnElementConstructor } from "../ColumnElementConstructor";
import { Custom } from "./Custom";

/**
 * The `Text` component properties.
 */

export interface TextProps extends Omit<BaseColumnProps, "align"> {
  formatValue?: (value: unknown) => string;
}

/**
 * Column which displays basic text values.
 */

export const Text: FC<TextProps> = (props) => {
  const { formatValue, ...rest } = props;
  return (
    <Custom {...rest}>
      {(value) => {
        if (value === null || value === undefined) return "--";
        if (typeof value === "string" && !value) return "--";
        if (formatValue) {
          return formatValue(value);
        }
        if (typeof value === "string") return value;
        if (typeof value === "number" || typeof value === "boolean") return value.toString();
        if (typeof value === "object" && value !== null) return JSON.stringify(value);
        return Object.prototype.toString.call(value);
      }}
    </Custom>
  );
};

(Text as ColumnElementConstructor<TextProps>).className = "text";
(Text as ColumnElementConstructor<TextProps>).headerAlignment = "left";
